import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2h8x6r9yrt: FaireBrandEntity = {
  token: "b_2h8x6r9yrt",
  type: "brand",
  name: "Kettle & Fire",
  avatarUrl:
    "https://cdn.faire.com/fastly/1c6fbf15a6c922f022066fea64686ba4242e18e9207f941792e9311c7e0d23ab.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/520c91f1bdeab75f34d7406454f12834405a1ae38aa24125690208b23c6eb686.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1c6fbf15a6c922f022066fea64686ba4242e18e9207f941792e9311c7e0d23ab.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/520c91f1bdeab75f34d7406454f12834405a1ae38aa24125690208b23c6eb686.jpeg",
  location: "Austin, TX, USA",
  minimumOrderDollars: 152,
  rating: 4.9,
  reviewCount: 39,
  isInsider: true,
  description:
    "Kettle & Fire was founded in 2015 by Justin and Nick Mares in an effort to fill a need. Convenient, well-sourced, nutrient-dense + delicious bone broths were not available on the market. \n\nWe combine marrow bones with 100% organic spices, herbs, and vegetables with filtered water in steel kettles. The mixture is slow-simmered for 20-24 hours at 130 F. This provides enough time for nutrients, collagen, and amino acids to soak into the broth.\n\nWe maintain strict standards to deliver bone broth made from the bones of cattle and chicken that are humanely raised, with no antibiotics or hormones, 100% grass-fed and grass-finished.\n\n- NO additives or preservatives\n- NO antibiotics or hormones\n- NO artificial flavors or colors\n- NO extra sodium\n\nJust simmer our bone broth for five minutes on the stovetop and it’s ready to sip! Or just pour it into a mug and microwave for a minute!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:35.502Z",
    importedBy: "entity-db-cli",
  },
};
